import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function GallerySection() {
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const apiUrl = "/api/home/gallery-slider";

  useEffect(() => {
    fetch(apiUrl)
      .then((r) => {
        if (!r.ok) throw new Error("Failed to fetch gallery images");
        return r.json();
      })
      .then((data) => {
        setImages(data);
        setLoading(false);
      })
      .catch((err) => {
        setError(err.message || "Unknown error");
        setLoading(false);
      });
  }, [apiUrl]);

  return (
    <section id="speakers" className="parallax-section">
      <div className="container">
        <div className="row">
          <div className="col-md-12 col-sm-12 wow bounceIn">
            <div className="section-title text-center">
              <h2>Gallery</h2>
              <p>Photos from our previous events</p>
            </div>
          </div>
          <div className="row">
            {loading && (
              <div className="col-12 text-center">Loading gallery...</div>
            )}
            {error && (
              <div className="col-12 text-center" style={{ color: "red" }}>{error}</div>
            )}
            {!loading && !error && images.map((img, i) => (
              <div
                key={i}
                className="col-md-4 col-sm-6 wow fadeInUp"
                data-wow-delay={`0.${3 + i}s`}
              >
                <div className="gallery-thumb">
                  <img
                    src={img.imageURL}
                    className="img-responsive"
                    alt={img.caption || `Event ${i + 1}`}
                    style={{
                      width: "100%",
                      height: "auto",
                      borderRadius: 8,
                      boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
                      marginBottom: 8,
                    }}
                    onError={(e) =>
                      (e.target.src =
                        "https://via.placeholder.com/400x250?text=Image+Not+Found")
                    }
                  />
                  <div style={{ textAlign: "center", fontWeight: "500" }}>
                    {img.caption}
                  </div>
                </div>
              </div>
            ))}
          </div>
          {/* View All button */}
          <div className="row" style={{ marginTop: 16 }}>
            <div className="col-md-12 text-center">
              <button
                className="btn btn-primary"
                style={{ minWidth: 120, marginTop: 12, backgroundColor: "#222" }}
                onClick={() => navigate("/gallery")}
              >
                View All
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
